import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function fileMustBeUploaded(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {

    const values = control.value;
    if (values.status === 'error') {
      return {
        description: values.description,
        code: '300',
      };
    }
    if (values.fileUrl) {
      return null;
    }
    if (values.fileUrl === '') {
      return {
        description: '',
        code: '300',
      };
    }
    return null;
  };
}
